<vhv-common-header>
    <ng-container progress>
        <div class="m-progress-bar">
            <div class="m-progress-bar__value" [style.width]="getProgress()*100 + '%'"></div>
            <div class="m-progress-bar__label"></div>
        </div>
    </ng-container>

    <ng-container tools>

        <button *ngIf="isEingabenSichernButtonSichtbar"
                type="button"
                class="m_header__responsive_buttons m_header__eingaben_sichern_button"
                style="margin-right: 1em"
                (click)="eingabenSichernClick()" >
            <span class="mdi mdi-link-variant"></span>
            <span class="m-header__nav-text">Eingaben sichern</span>
        </button>

        <button *ngIf="isPreisvorschlagHerunterladenButtonSichtbar"
                type="button"
                class="m_header__responsive_buttons m_header__preisvorschlag_button"
                style="margin-right: 1em"
                (click)="preisvorschlagHerunterladenClick()" >
            <span class="mdi mdi-file-download"></span>
            <span class="m-header__nav-text">Preisvorschlag herunterladen</span>
        </button>

        <button *ngIf="isKontaktdatenButtonSichtbar"
                type="button"
                class="contact-phone m_header__responsive_buttons"
                (click)="showSupport()">
            <span class="mdi mdi-phone"></span>
            <span class="m-header__nav-text">Kontakt</span>
        </button>

    </ng-container>
</vhv-common-header>
